'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var BreakpointsConstants = {
    'xs': 0,
    'sm': 576,
    'md': 768,
    'lg': 992,
    'xl': 1200
};

exports.default = BreakpointsConstants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/breakpoints.constants.js
// module id = 409
// module chunks = 0